import { RefObject, useLayoutEffect, useRef } from "react";

/**
 * Scroll the grid so the rule at `targetPx` (offset from the lane top) sits
 * 12px (the grid row's top padding) under the sticky header, leaving its hour
 * label visible, once per `scrollKey` (a newly viewed day). Later changes
 * to the target (the "now" hour ticking over) don't move the user's scroll.
 * A layout effect, so the first painted frame is already at the target (no
 * frame at 12 AM followed by a jump).
 */
export function useInitialScroll(
  ref: RefObject<HTMLElement | null>,
  targetPx: number,
  scrollKey: string,
) {
  const latestTarget = useRef(targetPx);
  // Declared first: layout effects run in order, so the scroll below reads
  // this render's target.
  useLayoutEffect(() => {
    latestTarget.current = targetPx;
  });
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.scrollTop = Math.max(0, latestTarget.current);
  }, [ref, scrollKey]);
}
